import { ErrorMessage } from 'formik'
import TextError from './TextError'
import { useStyles } from './styles'
import React, { useRef, useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import PublishIcon from '@material-ui/icons/Publish'
import InputLabel from '@material-ui/core/InputLabel'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
const DocumentField = (props) => {
  const classes = useStyles()
  const { label, name, onValueChange, value } = props
  const hiddenFileInput = useRef(null)
  const handleClick = (id, event) => {
    hiddenFileInput.current.click()
  }
  useEffect(() => {
    hiddenFileInput.current.value = null
  }, [props])
  const [filename, setFileName] = useState(null)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackBarType, setSnackBarType] = useState(null)
  const handleSnackBarClose = () => {
    setOpenSnackBar(false)
  }
  return (
    <div className={classes.formDocumentField}>
      <InputLabel htmlFor={name} className={classes.formOptionElement}>
        {label} <ErrorMessage name={name} component={TextError}></ErrorMessage>
      </InputLabel>
      <div className={classes.formDocumentButtonFlex}>
        <Button
          className={classes.formDocumentUploadButton}
          variant="contained"
          onClick={(event) => handleClick(event)}
        >
          <PublishIcon className={classes.publishIcon} />
          Upload
        </Button>
        <div className={classes.formUploadedFileName}>
          {value ? filename : null}
        </div>
      </div>
      <div style={{ padding: '1em', fontSize: '0.8em', color: 'grey' }}>
        File number limit : 1 | Single file size limit : 10MB | Allowed file
        types : PDF
      </div>
      <input
        type="file"
        data-testid={name}
        ref={hiddenFileInput}
        onChange={(event) => {
          if (
            event.target.files[0].type === 'application/pdf' &&
            event.target.files[0].size <= 10000000
          ) {
            setFileName(event.target.files[0].name)
            onValueChange(event)
          } else {
            setOpenSnackBar(true)
            if (event.target.files[0].type !== 'application/pdf')
              setSnackBarType('FILE_UPLOAD_TYPE')
            else setSnackBarType('FILE_SIZE_TYPE')
          }
        }}
        style={{ display: 'none' }}
      />
      {snackBarType ? (
        snackBarType === 'FILE_UPLOAD_TYPE' ? (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleSnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleSnackBarClose} severity="warning">
              Please upload files of PDF type
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleSnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleSnackBarClose} severity="warning">
              Please upload files of size less than 10 MB
            </Alert>
          </Snackbar>
        )
      ) : null}
    </div>
  )
}

export default DocumentField
